import React, { useState } from 'react'
import { Body, Box, CenteredBox } from '../layout'
import './DropDown.scss'

export const DropDown = ({ items, value, onChange }) => {
  const [open, setOpen] = useState(false)

  const selectItem = index => {
    onChange?.(index)
    setOpen(false)
  }

  return (
    <CenteredBox
      className="drop-down"
      container
      p="12px 24px"
      height={48}
      r={24}
      border="2px solid black"
      background="white"
      color="black"
      cursor="pointer"
      userSelect="none"
    >
      <Box fullWidth justifyContent="space-between" gap={8} onClick={() => setOpen(open => !open)}>
        <Body size={16} weight={600} noWrap>
          {items[value]}
        </Body>
        <Box justifyContent="center" alignItems="center">
          <ChevronDown />
        </Box>
      </Box>

      <Box
        column
        position="absolute"
        top="100%"
        left={0}
        r={24}
        p="8px 0"
        background="white"
        border="2px solid black"
        overflow="hidden"
        opacity={open ? 1 : 0}
      >
        {items.map((x, i) =>
          <Box
            className="drop-down-item"
            fullWidth
            p="4px 16px"
            cursor="pointer"
            onClick={() => selectItem(i)}
            key={i}
          >
            <Body small alt weight={600} noWrap>
              {x}
            </Body>
          </Box>
        )}
      </Box>
    </CenteredBox>
  )
}

const ChevronDown = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.293 8.86621L12 13.1592L7.70697 8.86621L6.29297 10.2802L12 15.9872L17.707 10.2802L16.293 8.86621Z" fill="#1E1E1E"/>
  </svg>
)